import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { authApi } from "../lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    if (!token) {
      setError("Hiányzó vagy érvénytelen link.");
      return;
    }
    if (password !== password2) {
      setError("A két jelszó nem egyezik.");
      return;
    }
    setBusy(true);
    try {
      const data = await authApi.resetPassword(token, password);
      setMessage(data.message || "Jelszó frissítve.");
    } catch (err) {
      setError(err.message || "Hiba történt.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 pt-24 pb-16">
      <h1 className="text-3xl font-bold mb-2">Új jelszó</h1>
      <p className="text-gray-600 mb-8">Add meg az új jelszavad (min. 8 karakter).</p>
      <form onSubmit={onSubmit} className="space-y-4">
        {error && (
          <div className="rounded-lg border border-red-200 bg-red-50 text-red-800 px-3 py-2 text-sm">
            {error}
          </div>
        )}
        {message && (
          <div className="rounded-lg border border-emerald-200 bg-emerald-50 text-emerald-900 px-3 py-2 text-sm">
            {message}{" "}
            <Link to="/bejelentkezes" className="underline">
              Bejelentkezés
            </Link>
          </div>
        )}
        <label className="block">
          <span className="text-sm font-medium">Új jelszó</span>
          <input
            type="password"
            required
            minLength={8}
            className="mt-1 w-full border rounded-lg px-3 py-2"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium">Új jelszó újra</span>
          <input
            type="password"
            required
            minLength={8}
            className="mt-1 w-full border rounded-lg px-3 py-2"
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
          />
        </label>
        <button
          type="submit"
          disabled={busy || !!message}
          className="w-full bg-[#0c1a26] text-[#f5e9cb] rounded-lg py-2.5 font-medium disabled:opacity-60"
        >
          {busy ? "Mentés…" : "Jelszó mentése"}
        </button>
      </form>
    </div>
  );
}
